// src/components/OnlineUsersPage/OnlineUsersPage.jsx
import React, { useEffect, useState } from 'react';
import { useSocket } from '../../../context/SocketContext';
import styles from './OnlineUsersPage.module.css';

export default function OnlineUsersPage() {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const socket = useSocket();

  useEffect(() => {
    if (!socket) return;

    socket.emit('subscribe:presence:any');
    socket.on('user:presence:update', users => {
      setOnlineUsers(users);
    });

    return () => {
      socket.off('user:presence:update');
      socket.emit('unsubscribe:presence:any');
    };
  }, [socket]);

  return (
    <div className={styles.onlineUsersPage}>
      <h1 className={styles.heading}>Кто онлайн</h1>
      <ul className={styles.userList}>
        {onlineUsers.length > 0 ? (
          onlineUsers.map(u => (
            <li key={u.id} className={styles.userItem}>
              <span className={styles.name}>{u.firstName} {u.lastName}</span>
              &nbsp;
              <span className={styles.username}>@{u.username}</span>
            </li>
          ))
        ) : (
          <li className={styles.noOnline}>Сейчас никого нет</li>
        )}
      </ul>
    </div>
  );
}